import {useState} from 'react';
import {TableBatchAction, Loading, InlineNotification} from '@carbon/react';
import {Save} from '@carbon/icons-react';
import {shouldDisplayErrorId, ParsedApiError} from '../../../../lib/error-handler';
import handleError from '../../../../lib/error';

export interface SaveRosterButtonProps {
    onUpdate: () => Promise<void>;
    revisionId: number;
    setModalOpen: (open: boolean) => void;
}

export function SaveRosterButton({onUpdate, revisionId, setModalOpen}: SaveRosterButtonProps) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<ParsedApiError | null>(null);

    const handleUpdate = async () => {
        setLoading(true);
        setError(null);
        try {
            await onUpdate();
        } catch (err) {
            const parsedError = handleError(err as Error, null, 'Failed to update roster');
            if (!parsedError.isAbortError) {
                setError(parsedError);
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <TableBatchAction
                iconDescription={revisionId === 0 ? 'Save' : 'Update'}
                renderIcon={loading ? () => <Loading withOverlay={false} small /> : Save}
                onClick={() => {
                    if (revisionId === 0) setModalOpen(true);
                    else handleUpdate();
                }}
            >
                {revisionId === 0 ? 'Save New Roster' : 'Update Roster'}
            </TableBatchAction>
            {error && revisionId !== 0 && (
                <InlineNotification
                    kind='error'
                    title='Error'
                    subtitle={
                        error.message +
                        (error.errorId && shouldDisplayErrorId(error.errorId)
                            ? ` (Error ID: ${error.errorId})`
                            : '')
                    }
                />
            )}
        </>
    );
}
